import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Button, Input, Space, Row, Col, InputNumber, DatePicker } from 'antd';
import { isMobile } from 'react-device-detect';
import BaseSelect from '@/components/Elements/BaseSelect';
import { _newLine, isValidDateForm } from '@/utils/helpers';
import ImageSelector from '@/components/ImageSelector';
import { createCardIssuedCount, updateCardIssuedCount } from '@/redux/actions/cardIssuedCountActions';
import { fetchActiveCardTypes } from '@/redux/actions/cardTypeActions';
import moment from 'moment';
import { fetchActiveCustomers } from '@/redux/actions/customerActions';

class CardIssuedCountForm extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            images: null
        };
    }
    componentDidMount() {
        this.props.fetchActiveCustomers();
        this.props.fetchActiveCardTypes();
    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ isLoading: true });
                try {
                    const sourceImages = this.state.images === null
                        ? (this.props.currentItem?.images || [])
                        : this.state.images;
                    values.images = sourceImages.map(image => ({
                        manual_id: image.manual_id || image.id,
                        src: image.src || image.originalImage || image.url
                    })).filter(image => image.src);
                    values.issuance_date = values.issuance_date ? values.issuance_date.format("YYYY-MM-DD") : null;

                    if (this.props.currentItem) {
                        await this.props.updateCardIssuedCount(this.props.currentItem.id, values);
                    } else {
                        await this.props.createCardIssuedCount(values);
                    }
                    this.props.reloadData();
                    this.onClose();
                } catch (error) {
                    this.setState({ isLoading: false });
                }
            }
        });
    }

    onClose() {
        this.props.onCancel();
        this.props.form.resetFields();
        this.setState({ isLoading: false, images: null });
    }

    handleImageChange = fileList => {
        this.setState({ images: fileList || [] });
    };

    render() {
        var { isLoading } = this.state;
        var {
            visible,
            currentItem,
            activeCardTypes,
            customerActiveList
        } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <Drawer
                visible={visible}
                title={currentItem ? 'Cập nhật bản ghi' : `Thêm bản ghi`}
                onOk={(e) => this.submit(e)}
                onClose={() => this.onClose()}
                maskClosable={false}
                width={isMobile ? '100%' : '50%'}
                footer={
                    <div style={{ textAlign: 'right', }}>
                        <Space>
                            <Button key="back" onClick={() => this.onClose()}>
                                Huỷ
                            </Button>
                            <Button
                                loading={isLoading}
                                key="submit"
                                type="primary"
                                onClick={(e) => this.submit(e)}
                            >
                                {currentItem ? 'Cập nhật' : "Thêm mới"}
                            </Button>
                        </Space>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <Form.Item label="Loại thẻ">
                                    {getFieldDecorator('card_type_id', {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.card_type_id : null
                                    })(
                                        <BaseSelect
                                            options={activeCardTypes ?? []}
                                            showSearch
                                            optionValue="id"
                                            optionLabel="name"
                                            placeholder="Loại thẻ"
                                            className="w-100"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Số lượng thẻ đã phát">
                                    {getFieldDecorator('quantity', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng chọn!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.quantity : null
                                    })(<InputNumber min={1} precision={0} className='w-100' />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Nơi phát">
                                    {getFieldDecorator('issuance_place', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.issuance_place : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Địa chỉ">
                                    {getFieldDecorator('address', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.address : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Số điện thoại">
                                    {getFieldDecorator('phone', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.phone : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Người nhận">
                                    {getFieldDecorator('recipient', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.recipient : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Khách hàng">
                                    {getFieldDecorator('customer_id', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.customer_id : null
                                    })(
                                        <BaseSelect
                                            options={customerActiveList ?? []}
                                            showSearch
                                            optionValue="id"
                                            optionLabel="full_name"
                                            placeholder="Chọn khách hàng"
                                            className="w-100"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Ngày phát">
                                    {getFieldDecorator('issuance_date', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng chọn!',
                                            },
                                        ],
                                        initialValue: currentItem ? isValidDateForm(currentItem.issuance_date, false) : moment()
                                    })(
                                        <DatePicker
                                            className='w-100'
                                            format="DD/MM/YYYY"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Mã thẻ đã phát">
                                    {getFieldDecorator('card_number', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.card_number : null
                                    })(<Input.TextArea rows={3} />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Ghi chú">
                                    {getFieldDecorator('note', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentItem ? _newLine(currentItem.note) : null
                                    })(
                                        <Input.TextArea rows={3} />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Ảnh" className='flex-upload'>
                                    <ImageSelector
                                        key={currentItem?.id || 'new'}
                                        multiple
                                        maxCount={30}
                                        uploadText="Chọn ảnh"
                                        defaultFileList={currentItem?.images || []}
                                        onChangeData={this.handleImageChange}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    : null
                }
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {
        activeCardTypes: state.cardTypeReducer.activeItems,
        customerActiveList: state.customerReducer.customerActiveList
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createCardIssuedCount: data => dispatch(createCardIssuedCount(data)),
        updateCardIssuedCount: (id, data) => dispatch(updateCardIssuedCount(id, data)),
        fetchActiveCardTypes: () => dispatch(fetchActiveCardTypes()),
        fetchActiveCustomers: () => dispatch(fetchActiveCustomers())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CardIssuedCountForm' })(CardIssuedCountForm));
